import { Injectable } from '@angular/core';

interface UploadedFile {
  name: string;
  size: number;
  file: File;
  status: 'pending' | 'success' | 'error';
  csvHeaders?: string[];
  columnMapping?: ColumnMapping;
  needsMapping?: boolean;
}

interface ColumnMapping {
  MD: string;
  INC: string;
  AZI: string;
}

interface UploadResult {
  filename: string;
  api?: string;
  flag?: boolean;
  distance?: number;
  tolerance?: number;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class UploadStateService {
  uploadedFiles: UploadedFile[] = [];
  uploadResults: UploadResult[] = [];
  uploadError: string | null = null;
  toleranceThreshold: number | null = null;
  selectedEpsgCode: number = 32065;

  clearAll(): void {
    this.uploadedFiles = [];
    this.uploadResults = [];
    this.uploadError = null;
  }
}
